import { CategorySettingsIcon } from 'assets/icons/category-settings';
import React from 'react';
import { cn } from 'utils';

interface CategoryProps {
  title: string;
  quantity: number;
  primaryColor: string;
  secondaryColor: string;
}

const Category: React.FC<CategoryProps> = ({
  title,
  quantity,
  primaryColor,
  secondaryColor,
}) => {
  return (
    <div
      className={cn(
        'flex-1 rounded-lg flex flex-row items-center justify-between py-[8px] px-[12px] box-border min-w-[165px] gap-[20px]'
      )}
      style={{ backgroundColor: primaryColor }}
    >
      <div className="flex flex-row items-center justify-start gap-[8px]">
        <span className="relative text-[12px] font-medium text-[#010D1D] text-left min-w-[52px]">
          {title}
        </span>
        <div
          className={cn(
            'rounded-[4px] overflow-hidden flex items-center justify-center'
          )}
          style={{ backgroundColor: secondaryColor }}
        >
          <span className="flex items-center justify-center text-[12px] min-w-[25px] h-[25px] font-medium text-[#F6FCFF]">
            {quantity}
          </span>
        </div>
      </div>
      <CategorySettingsIcon />
    </div>
  );
};

export default Category;
